import { pageAnimation } from 'src/shared/utils/pageAnimation';

interface AnimateGoalScreenProps {
  updateGoalScreenData: () => void;
  direction: 'forward' | 'back';
}

export const animateGoalScreen = ({ updateGoalScreenData, direction }: AnimateGoalScreenProps) => {
  const baseEl = document.querySelector('ion-router-outlet[animated="true"]');
  updateGoalScreenData();

  if (baseEl) {
    const leavingEl = baseEl.cloneNode(true) as HTMLElement;
    leavingEl.style.position = 'absolute';
    leavingEl.style.top = '0';
    leavingEl.style.left = '0';
    leavingEl.style.width = '100%';
    baseEl.parentElement?.appendChild(leavingEl);

    pageAnimation(baseEl as HTMLElement, {
      enteringEl: baseEl,
      leavingEl: leavingEl,
      direction,
    })
      .play()
      .then(() => {
        leavingEl.remove();
      });
  }
};
